import { useAuth } from '@/hooks/use-auth'
import { useMyProfile, useUpdateMember } from '@/hooks/use-members'
import { MemberProfileView } from '@/components/profile/member-profile-view'
import type { ManageableMemberStatus, MemberDetail } from '@riverpark/types'

export function ProfilePage() {
  const { user } = useAuth()
  const { data, isLoading, error } = useMyProfile()
  const updateMember = useUpdateMember()

  const profile = data?.data

  async function handleSave(payload: {
    name: string
    email: string
    phone: string
    role: MemberDetail['role']
    status?: ManageableMemberStatus
  }) {
    if (!user) throw new Error('Not signed in')
    await updateMember.mutateAsync({
      id: user.id,
      body: {
        name: payload.name,
        email: payload.email,
        phone: payload.phone,
      },
    })
  }

  return (
    <MemberProfileView
      profile={profile}
      isLoading={isLoading}
      error={error instanceof Error ? error : null}
      isSelf
      canManageRole={false}
      canManagePlots={false}
      canDelete={false}
      onSave={handleSave}
      isSavePending={updateMember.isPending}
      isDeactivatePending={false}
      isResendPending={false}
    />
  )
}
